"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Note = require("./Note.style");

var _excluded = ["text"];

var Note = function Note(_ref) {
  var text = _ref.text,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Note.StyledNote, props, /*#__PURE__*/_react["default"].createElement(_Note.StyledText, null, text));
};

Note.defaultProps = {
  bg: '#FFCCD7',
  position: 'bottomLeft'
};
Note.propTypes = {
  width: _propTypes["default"].number,
  className: _propTypes["default"].string,
  height: _propTypes["default"].number,
  text: _propTypes["default"].string,
  bg: _propTypes["default"].string,
  color: _propTypes["default"].string,
  position: _propTypes["default"].oneOf(['topLeft', 'topRight', 'bottomLeft', 'bottomRight'])
};
var _default = Note;
exports["default"] = _default;